if (!customElements.get("custom-swiper")) {
  customElements.define("custom-swiper", class CustomSwiper extends HTMLElement {
    initialized = false;
    sleeping = false;
    constructor() {
      super();
      this.lazyInit = this.hasAttribute('data-lazy-init');
      if (!this.lazyInit) {
        this.init();
      }
    }
    swipeTo(index) {
      if (this.swiper) {
        this.swiper.slideTo(index);
      }
    }
    onMouseEnter() {
      // this.swiper.autoplay.stop();
    }
    onMouseOut() {
      // this.swiper.autoplay.start();
    }
    connectedCallback() {

    }

    init() {
      if (this.initialized) return;
      this.swiperContainer = this.querySelector(".swiper-container");
      if (this.dataset.config) {
        this.config = JSON.parse(this.dataset.config);
      }

      this.swiper = null;
      this.prev = this.querySelector("[data-swiper-prev-button]");
      this.next = this.querySelector("[data-swiper-next-button]");
      this.scrollbar = this.querySelector("[data-scrollbar]");
      this.isPauseOnMounseenter = this.hasAttribute("data-pause-onmouseenter");
      this.pagination = this.querySelector("[data-pagination]");
      this.initializedInMobile = false;

      const config = {
        ...this.config
      }
      if (this.prev && this.next) {
        config.navigation = {
          prevEl: this.prev,
          nextEl: this.next
        }
      }
      if (this.scrollbar) {
        config.scrollbar = {
          el: this.scrollbar
        }
      }
      if (this.pagination) {
        config.pagination = {
          el: this.pagination
        }
      }
      this.swiper = new Swiper(this.swiperContainer, config);

      if (this.isPauseOnMounseenter) {
        // 鼠标放在上面暂停，未完成
        this.addEventListener("mouseenter", this.onMouseEnter.bind(this))
        this.addEventListener("mouseleave", this.onMouseOut.bind(this))

      }
      this.addEventListener("swipeTo", e => { this.swipeTo.bind(this, e.detail.index)(); });

      this.detailContainer = this.closest("[data-detail-content]");
      if (this.detailContainer) {
        this.detailContainer.addEventListener("custom:detail:open", () => {
          if (!this.initializedInMobile) {

            setTimeout(() => {
              // 冲新初始化一下
              this.swiper = new Swiper(this.swiperContainer, config);
              this.initializedInMobile = true;
            }, 1000)
          }
        })
      }
      this.initialized = true;
    }

    /**
     * 睡眠，即 Swiper 不可见时，降低资源消耗
     */
    sleep() {
      if (!this.sleeping) {
        // 停止自动轮播
        if (this.config?.autoplay && this.swiper?.autoplay?.stop) {
          this.swiper?.autoplay?.stop();
        }
        this.sleeping = true;
      }
    }

    /**
     * 从睡眠中恢复
     */
    resume() {
      if (!this.initialized) {
        this.init();
        this.sleeping = false;
      } else if (this.sleeping) {
        // 恢复自动轮播
        if (this.config?.autoplay && this.swiper?.autoplay?.start) {
          this.swiper?.autoplay?.start();
        }
        this.sleeping = false;
      }
    }
  })
}